import { createAsyncSliceWithDataAndQuery } from 'store/createAsyncSliceWithDataAndQuery';
import { createAsyncSlice } from 'store/createAsyncSlice';
import {
  getTaxCertificationRequestsAsync,
  patchTaxCertificationETAAsync,
  postSendTaxCertificationToSpruceAsync,
} from '../../../API/vendorDashboard/VendorAPI';
import { createDefaultVendorTaxCertificationRequestsData } from '../../../types/vendorDashboard/IVendorTaxCertificationInformation';

export const { slice: taxCertificationRequestsSlice, asyncAction: getTaxCertificationRequestsAsyncAction } =
  createAsyncSliceWithDataAndQuery(
    'taxCertificationRequestsSlice',
    getTaxCertificationRequestsAsync,
    createDefaultVendorTaxCertificationRequestsData()
  );

export const { slice: sendToSpruceSlice, asyncAction: sendToSpruceAsyncAction } = createAsyncSlice(
  'sendToSpruceSlice',
  postSendTaxCertificationToSpruceAsync
);

export const { slice: updateVendorTaxCertificationSlice, asyncAction: patchTaxCertificationETAAsyncAction } =
  createAsyncSlice('updateVendorTaxCertificationSlice', patchTaxCertificationETAAsync);
